class AddObligationBasisLineModalController {
  constructor($uibModalInstance, $http, $rootScope, toastr, contractId, obligation, obligationLabel) {
    'ngInject';

    this.$uibModalInstance = $uibModalInstance;
    this.$http = $http;
    this.$rootScope = $rootScope;
    this.toastr = toastr;
    this.contractId = contractId;
    this.obligation = obligation || {};
    this.obligationLabel = obligationLabel || '';
    this.loading = false;
    this.saving = false;
    this.eligibleBases = [];
    this.selectedBasis = null;
    this.model = {
      fixedFeeBasisId: null,
      fundedHours: null
    };

    this.loadEligibleBases();
  }

  getDisplayFractionDigits(value, maxDigits = 5, minDigits = 2) {
    const num = Number(value);
    if (!isFinite(num)) {
      return minDigits;
    }
    const decimalPart = Math.abs(num).toFixed(maxDigits).split('.')[1] || '';
    let digits = maxDigits;
    while (digits > minDigits && decimalPart.charAt(digits - 1) === '0') {
      digits--;
    }
    return digits;
  }

  formatMoney(value) {
    const num = Number(value) || 0;
    const digits = this.getDisplayFractionDigits(num);
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: digits,
      maximumFractionDigits: digits
    }).format(num);
  }

  isFeeObligation() {
    return this.obligation && this.obligation.costElement === 'FIXED_FEE';
  }

  basisOptionLabel(basis) {
    if (!basis) {
      return '';
    }
    const parts = [
      basis.laborCategoryName || 'Labor Category',
      basis.modLabel || null,
      basis.effectiveDate || null
    ].filter(Boolean);
    return parts.join(' · ');
  }

  onBasisChanged() {
    const id = this.model && this.model.fixedFeeBasisId;
    this.selectedBasis = (this.eligibleBases || []).find((b) => String(b.id) === String(id)) || null;
  }

  selectedRate() {
    if (!this.selectedBasis) {
      return 0;
    }
    if (this.isFeeObligation()) {
      return Number(this.selectedBasis.fixedFeePerHour) || 0;
    }
    return Number(this.selectedBasis.fullyLoadedLaborRate) || 0;
  }

  rateTypeLabel() {
    return this.isFeeObligation() ? 'Fixed Fee / Hour' : 'Fully Loaded Labor';
  }

  previewAmount() {
    return this.selectedRate() * (Number(this.model && this.model.fundedHours) || 0);
  }

  loadEligibleBases() {
    if (!this.contractId || !this.obligation || !this.obligation.id) {
      this.eligibleBases = [];
      return;
    }

    this.loading = true;
    this.$http.get(
      `${this.$rootScope.apiHost}/api/admin/contracts/${this.contractId}`
        + `/funding-obligations/${this.obligation.id}/eligible-fixed-fee-bases`,
      { withCredentials: true }
    ).then((success) => {
      this.eligibleBases = success.data || [];
    }, (failure) => {
      this.eligibleBases = [];
      const message = (failure && failure.data && failure.data.message)
        || 'Failed to load fixed fee bases';
      this.toastr.error(message, 'ERROR');
    }).finally(() => {
      this.loading = false;
    });
  }

  canSave() {
    const model = this.model || {};
    return !!(model.fixedFeeBasisId
      && model.fundedHours != null
      && model.fundedHours !== ''
      && Number(model.fundedHours) >= 0
      && !this.saving
      && !this.loading);
  }

  save() {
    if (!this.canSave()) {
      return;
    }

    this.saving = true;
    const payload = {
      fixedFeeBasisId: Number(this.model.fixedFeeBasisId),
      fundedHours: Number(this.model.fundedHours)
    };

    this.$http.post(
      `${this.$rootScope.apiHost}/api/admin/contracts/${this.contractId}`
        + `/funding-obligations/${this.obligation.id}/basis-lines`,
      payload,
      { withCredentials: true }
    ).then((success) => {
      this.toastr.success('Basis line added');
      this.$uibModalInstance.close(success.data);
    }, (failure) => {
      const message = (failure && failure.data && failure.data.message) || 'Failed to add basis line';
      this.toastr.error(message, 'ERROR');
    }).finally(() => {
      this.saving = false;
    });
  }

  cancel() {
    this.$uibModalInstance.dismiss();
  }
}

export default AddObligationBasisLineModalController;



// WEBPACK FOOTER //
// ./client/common/modals/addObligationBasisLineModal/addObligationBasisLineModal.controller.js